<template>
  <v-container flat>
    <v-layout justify-center>
      <h3>特勤访客注册登记</h3>
    </v-layout>
    <v-form ref="form">
      <v-layout column>
        <v-flex xs12 class="py-1">
          <v-text-field
            :rules="[$rules.requiredS()]"
            label="访客姓名"
            placeholder="请输入您的姓名"
            prepend-icon="mdi-account"
            v-model="form.name"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 class="py-1">
          <v-text-field
            :rules="[$rules.requiredS(), $rules.idNumber()]"
            label="身份证号"
            placeholder="请输入身份证号"
            prepend-icon="$vuetify.icons.idCard"
            v-model="form.idCard"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 class="py-1">
          <v-text-field
            label="单位名称"
            placeholder="请输入单位名称"
            prepend-icon="$vuetify.icons.group"
            v-model="form.orgName"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 class="py-1">
          <v-text-field
            :rules="$rules.phone11()"
            label="联系电话"
            placeholder="请输入联系电话"
            prepend-icon="mdi-phone"
            v-model="form.phone"
            type="number"
          ></v-text-field>
        </v-flex>
        <v-layout>
          <v-flex xs12>
            <v-text-field
              class="pb-1"
              single-line
              label="验证码"
              type="number"
              placeholder="请输入验证码"
              prepend-icon="$vuetify.icons.code"
              v-model="verifyObj.verifyCode"
              :disabled="disabledFlag === true"
              :error-messages="
                disabledFlag === true ? '' : verifyObj.errorMessage
              "
            ></v-text-field>
          </v-flex>
          <v-btn
            flat
            color="primary"
            @click="
              getTmpToken();
              verifyObj.getFlag = true;
            "
            :disabled="disabledFlag === true"
            v-if="verifyObj.expire <= 0"
          >
            <span v-if="!verifyObj.getFlag">获取短信验证码</span>
            <span v-else>重新获取</span>
          </v-btn>
          <span v-else style="font-size: 16px">{{ verifyObj.expire }}s</span>
        </v-layout>
      </v-layout>
    </v-form>
    <v-layout justify-center>
      <v-btn
        class="primary"
        @click="visitorSubmit"
        :loading="loading"
        :disabled="disabledFlag || verifyObj.verifyCode.length !== 4"
        >提交</v-btn
      >
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: "tempValidate",
  data() {
    return {
      verifyObj: {
        show: false,
        getFlag: false,
        expire: 0,
        key: "",
        verifyCode: "",
        verifyKey: "",
        errorMsg: "",
        checkStatus: false,
      },
      loading: false,
      disabledFlag: false,
      jsCode: "",
      form: {
        idCard: "",
        phone: "",
        name: "",
        orgName: "",
      },
    };
  },
  created() {
    this.jsCode = this.$route.query.code;
  },
  methods: {
    checkForm() {
      if (this.$refs.form.validate()) {
        return true;
      } else {
        this.$L.alert("error", { message: "表单数据错误" });
      }
    },
    async visitorSubmit() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        let checkRes = await this.checkCode();
        if (checkRes) {
          try {
            let extend = {
              name: this.form.name,
              idCard: this.form.idCard,
              orgName: this.form.orgName,
            };
            let param = {
              verifyKey: this.verifyObj.verifyKey,
              username: "",
              password: "",
              extend: JSON.stringify(extend),
            };
            let res = await this.$store.dispatch("wx/bindTempUser", {
              param: param,
              jsCode: this.jsCode,
              phone: this.form.phone,
            });
            if (res.data.status === 1) {
              this.$L.alert("success", { message: "注册成功" });
              let aim = this.$route.query.aim;
              if (
                aim.indexOf("selfSign") !== -1 ||
                aim.indexOf("personSelfSign") !== -1
              ) {
                let redirectUrl =
                  "https://smaco2.uestc.edu.cn/wx/autoLogin?aim=" + aim;
                window.location.href =
                  "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxfd33224488b5cf00&redirect_uri=" +
                  redirectUrl +
                  "&response_type=code&scope=snsapi_userinfo&state=1#wechat_redirect";
              } else {
                let redirectUrl =
                  "https://smaco2.uestc.edu.cn/wx/autoLogin?aim=" + aim;
                window.location.href =
                  "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxfd33224488b5cf00&redirect_uri=" +
                  redirectUrl +
                  "&response_type=code&scope=snsapi_userinfo&state=1#wechat_redirect";
              }
            } else {
              this.$L.alert("error", { message: res.data.msg });
              window.location.href =
                "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxfd33224488b5cf00&redirect_uri=https://smaco2.uestc.edu.cn/wx/validate&response_type=code&scope=snsapi_userinfo&state=1#wechat_redirect";
            }
          } catch (e) {
          } finally {
            this.loading = false;
          }
        } else {
          this.loading = false;
        }
      }
    },
    async getTmpToken() {
      if (!this.$refs.form.validate()) {
        this.$L.alert("error", { message: "表单数据有误" });
        return;
      }
      this.verifyObjReset();
      let res = await this.$store.dispatch(
        "letterReservation/selfSign_getTmpToken"
      );
      if (res.data.status === 1) {
        this.verifyObj.expire = 60;
        this.verifyObj.key = res.data.data.key;
        this.sendVertifyMessage();
      } else {
        this.$L.alert("error", { message: res.data.msg });
      }
    },
    async sendVertifyMessage() {
      let res = await this.$store.dispatch(
        "letterReservation/selfSign_getVerifyMsg",
        { key: this.verifyObj.key, phone: this.form.phone }
      );
      if (res.data.status === 1) {
        this.verifyObj.verifyKey = res.data.data.verifyKey;
      } else {
        this.$L.alert("error", { message: res.data.msg });
      }
    },
    async checkCode() {
      this.disabledFlag = true;
      let config = {
        verifyKey: this.verifyObj.verifyKey,
        realMsg: this.verifyObj.verifyCode,
      };
      let res = await this.$store.dispatch(
        "letterReservation/selfSign_checkVerify",
        config
      );
      if (res.data.status === 1) {
        this.verifyObjReset();
        return true;
      } else {
        this.$L.alert("error", { message: res.data.msg });
        this.disabledFlag = false;
        this.verifyObj.expire = -1;
        this.verifyObj.errorMsg = res.data.msg + ",请重新获取";
        return false;
      }
    },
    verifyObjReset() {
      this.verifyObj.show = false;
      this.verifyObj.getFlag = false;
      this.verifyObj.verifyCode = "";
      this.verifyObj.errorMsg = "";
      this.verifyObj.expire = 0;
    },
  },
  watch: {
    "verifyObj.expire"(val, oldVal) {
      if (val > 0) {
        if (val > oldVal) {
          setTimeout(() => {
            this.verifyObj.expire = val - 1;
          }, 1000);
        } else {
          setTimeout(() => {
            this.verifyObj.expire -= 1;
          }, 1000);
        }
      } else if (val === 0) {
        this.verifyObj.errorMessage = "验证码已过期，请重新获取";
      } else {
      }
    },
    "verifyObj.verifyCode"() {
      // console.log('change')
      this.verifyObj.errorMessage = "";
    },
  },
};
</script>

<style scoped>
</style>
